import React from 'react';
import PropTypes from 'prop-types';

import './styles.scss';

import { Row, Col } from 'reactstrap';

const CardDips = ({ dips }) => {
    const { title, description, price, image } = dips

    return (
        <Col lg="6" className="text-center text-md-start">
            <Row className="p-4 align-items-center">
                <Col xs="12" md="5" className="text-center text-md-start">
                    <img src={`images/dips/${image}.png`} alt={title} title={title} className="img-fluid"/>
                </Col>
                <Col xs="12" md="7" className="text-center text-md-start">
                    <h4 className="dip-title mb-0">{title}</h4>
                    {description && <p className="dip-description mb-0">{description}</p>}
                    <Row className="dip-prices">
                        <Col>
                            <p className="price-tag">${price}</p>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Col>
    );
}

CardDips.prototype = {
    dips: PropTypes.object.isRequired
};

export default CardDips;